const ArrowLeftIcon = ({ className = ''}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="78" height="48" viewBox="0 0 78 48" fill="none" className={`rotate-180 ${className}`}>
    <path d="M76.1232 21.5253L55.4993 0.90137L53.8494 2.55129L74.1318 22.8337L0.588417 22.8337L0.588418 25.1667L74.1318 25.1667L53.8494 45.4491L55.4993 47.099L76.1232 26.4751C77.4877 25.1106 77.4877 22.8898 76.1232 21.5253Z" fill="currentColor"/>
  </svg>
)


export default ArrowLeftIcon;
